import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/context/gpt-provider.tsx");
